import {Injectable} from '@angular/core';
import {ToastsManager} from 'ng2-toastr';

@Injectable()
export class NotificationService {

  constructor(public toastr: ToastsManager) {
  }

  success(text: string, title: string) {
    this.toastr.success(text, title);
  }

  error(text: string, title: string) {
    this.toastr.error(text, title);
  }

  warning(text: string, title: string) {
    this.toastr.warning(text, title);
  }

  info(text: string, title: string) {
    this.toastr.info(text, title);
  }
}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/notification.service.ts